import * as React from 'react';
import { Provider } from 'react-redux';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { Box, CssBaseline, styled, ThemeProvider } from '@mui/material';
import { store } from 'src/redux/store';
import { LoadScriptNext } from '@react-google-maps/api';
import LoadingScreen from 'src/frontend-common/components/LoadingScreen';
import lightTheme from 'src/frontend-common/style/theme';

const AppContainer: React.FC<{ children: any }> = ({ children }) => {
  return (
    <ThemeProvider theme={lightTheme}>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <CssBaseline />
        <Provider store={store}>
          <LoadScriptNext
            libraries={['places']}
            googleMapsApiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY || ''}
            loadingElement={
              <LoaderWrapper component="div">
                <LoadingScreen logo />
              </LoaderWrapper>
            }
          >
            {children}
          </LoadScriptNext>
        </Provider>
      </LocalizationProvider>
    </ThemeProvider>
  );
};

export default AppContainer;

const LoaderWrapper = styled(Box)(() => ({
  height: '100vh',
  width: '100vw',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
}));
